import React, { Component } from "react";
import { connect } from "react-redux";
import throttle from "lodash.throttle";
import CustomSelect from "../components/common/select/Select";
import PromotionMiddleware from "../store/prat_middleware/gt/promotionMiddleware";
import ProductMiddleware from "../store/prat_middleware/gt/productMiddleware";
import PromotionListMiddleware from "../store/prat_middleware/promotion/promotionListMiddleware";
import "./style/promotion_list.scss";
import CreatePromotion from "../store/prat_middleware/promotion/createPromotionMiddleware";
import { Loader } from ".././components/loader";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import { valueConverter_2 } from "../util-functions/util-funtions";
import DATA from "../assets/data";
import { compare } from "./gt/validation/sort";
import CustomToast from "../util-functions/customToast.jsx";

let detailData = [];

class PromotionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      division: "",
      category: "",
      selectedPromotionType: "",
      selectedPromotionLevel: "",
      selectedProductDevisions: "",
      selectedProductCategories: [],
      selectedProductSkus: [],
      selectedProductMasterSkus: [],
      selectedProductBrands: [],
      promotionType: [],
      promotionLevelType: "",
      myBrands: [],
      mySkus: [],
      myMasterSkus: [],
      selectedProductVariants: [],
      selectedProductFormats: [],
      counter: this.props.counter,
      selected_row: false,
      versionPage: 1,
      //   versions:[],
      data: [],
      isDraftLoading: false,
      selectAll_row: false,
      isLazyLoading: false,
      firstTime: true,
      selectedYear: new Date().getFullYear(),
      selectedWeekFrom: "",
      selectedWeekTo: "",
      selectedActivityStatus: [],
      activityCode: "",
      removePromo: true,
      bulkDuplicate: true,
      open: false,
      formType: "",
      receiveData: true,
      selectedActivityCode: [],
      totalData: "",
      bulkSendback: true,
      pushToDWOptios: [
        { value: true, name: "TRUE" },
        { value: false, name: "FALSE" },
      ],
      is_extended: [
        { value: true, name: "TRUE" },
        { value: false, name: "FALSE" },
      ],
      selectedPushToDW: '',
      selectedIsextended: '',
      currentYear: null,
      currentMonth: '',
      duplicationLoading: false,
      invoiceOptios: [
        { value: true, name: 'ON' },
        { value: false, name: 'OFF' }
      ],
      selectedInvoiceOption: '',
      selectedRPFailOption: '',
      isIceCream: false,
      onlyIceCream: false
    };
  }

  propsReceived = (value) => {
    if (this.state.data) {
      let arr = this.state.data;
      if (this.state.data.results) {
        value.forEach((item) => arr.results.push(item));
        this.setState({ isLazyLoading: false, data: arr, firstTime: false });
      }
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.promotion_extension_list !==
      this.props.promotion_extension_list &&
      nextProps.promotion_extension_list === true
    ) {
      this.setState(
        {
          data: [],
          bulkDuplicate: false,
          firstTime: true,
          versionPage: 1
        },
        () => {
          this.props.get_promotionList(
            this.state.versionPage,
            this.state.selectedYear,
            this.state.selectedWeekFrom,
            this.state.selectedWeekTo,
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus,
            this.state.selectedActivityStatus,
            this.state.selectedPromotionType,
            this.state.selectedActivityCode,
            this.state.selectedPushToDW,
            this.state.selectedIsextended,
            this.state.selectedInvoiceOption,
            this.state.selectedRPFailOption
          );
        }
      );
    }
    if (
      nextProps.promotion_list &&
      nextProps.promotion_list.results &&
      this.state.receiveData
    ) {
      this.setState({
        totalData: nextProps.promotion_list.total_count,
        receiveData: false,

      });
      this.propsReceived(nextProps.promotion_list.results);
    }
    if (nextProps.promotionDeletedSuccessfully && this.state.removePromo) {
      this.setState(
        {
          data: [],
          removePromo: false,
          firstTime: true,
          versionPage: 1,
        },
        () => {
          this.props.get_promotionList(
            this.state.versionPage,
            this.state.selectedYear,
            this.state.selectedWeekFrom,
            this.state.selectedWeekTo,
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus,
            this.state.selectedActivityStatus,
            this.state.selectedPromotionType,
            this.state.selectedActivityCode,
            this.state.selectedPushToDW,
            this.state.selectedIsextended,
            this.state.selectedInvoiceOption

          );
        }
      );
    }

    if ((nextProps.bulkDuplicatedSuccessfully && this.state.bulkDuplicate) || (nextProps.bulkDuplicatedNextYearSuccessfully && this.state.bulkDuplicate)) {
      this.setState(
        {
          data: [],
          bulkDuplicate: false,
          firstTime: true,
          versionPage: 1,
          duplicationLoading: false,
        },
        () => {
          this.props.get_promotionList(
            this.state.versionPage,
            this.state.selectedYear,
            this.state.selectedWeekFrom,
            this.state.selectedWeekTo,
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus,
            this.state.selectedActivityStatus,
            this.state.selectedPromotionType,
            this.state.selectedActivityCode,
            this.state.selectedPushToDW,
            this.state.selectedIsextended,
            this.state.selectedInvoiceOption,
            this.state.selectedRPFailOption
          );
        }
      );
    }

    if (nextProps.bulkSendBackSuccessfully && this.state.bulkSendback) {
      this.setState(
        {
          data: [],
          bulkSendback: false,
          firstTime: true,
          versionPage: 1,
        },
        () => {
          this.props.get_promotionList(
            this.state.versionPage,
            this.state.selectedYear,
            this.state.selectedWeekFrom,
            this.state.selectedWeekTo,
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus,
            this.state.selectedActivityStatus,
            this.state.selectedPromotionType,
            this.state.selectedActivityCode,
            this.state.selectedPushToDW,
            this.state.selectedIsextended,
            this.state.selectedInvoiceOption,
            this.state.selectedRPFailOption

          );
        }
      );
    }

    if (nextProps.bulkRpCallSuccessfully && this.state.bulkRPCall) {
      this.setState({
        data: [],
        bulkRPCall: false,
        firstTime: true,
        versionPage: 1,
      },
        () => {
          this.props.get_promotionList(
            this.state.versionPage,
            this.state.selectedYear,
            this.state.selectedWeekFrom,
            this.state.selectedWeekTo,
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus,
            this.state.selectedActivityStatus,
            this.state.selectedPromotionType,
            this.state.selectedActivityCode,
            this.state.selectedPushToDW,
            this.state.selectedIsextended,
            this.state.selectedInvoiceOption,
            this.state.selectedRPFailOption

          );
        })
    }
  }
  componentDidMount() {
    this.checkIsIceCream();
    const {
      get_AllPromotionType,
      get_promotionLevel,
      get_productBrands,
      get_productCategories,
      get_productDevisions,
      get_productMasterSkus,
      // get_productVariants,
      // get_productFormats,
    } = this.props;
    setTimeout(() => {
      get_AllPromotionType();
      get_promotionLevel();
      // get_productSkus();
      get_productMasterSkus();
      get_productBrands();
      get_productCategories();
      get_productDevisions();
      // get_productVariants();
      // get_productFormats();
      this.getDataOnComponentMount();
    }, 1000);

    if (this.props.promotion_list) {
    }

    this.page_wrapper_promotion.onscroll = (e) => {
      if (
        this.props.promotionListHasError ||
        this.state.data.results.length < 10
      )
        return;
      const obj = e.target;
      const height = obj.scrollHeight - obj.offsetHeight;
      const scrollPos = obj.scrollTop;
      const factor = 0.9;
      if (scrollPos >= factor * height) {
        this.load_more_versions();
      }
    };

    this.getCurrentYearAndMonth();
  }

  checkIsIceCream = () => {
    let user = JSON.parse(localStorage.getItem("myData"));
    let isTrue = false;
    let onlyIceCreamIsTrue = false;
    user.my_categories && user.my_categories.forEach(item => {
      if (item.category__Code === 11 && user.my_categories.length === 2) {
        onlyIceCreamIsTrue = true;
      }
      else if (item.category__Code === 11 && user.my_categories.length > 2) {
        isTrue = true;
      }
    })
    this.setState({
      isIceCream: isTrue,
      onlyIceCream: onlyIceCreamIsTrue
    })
  }

  getCurrentYearAndMonth = () => {
    let currentDate = new Date();
    let thisYear = currentDate.getFullYear();
    let thisMonth = currentDate.getMonth();
    this.setState({
      currentYear: thisYear,
      currentMonth: thisMonth,
    });
  };

  getDataOnComponentMount = () => {
    this.setState(
      {
        receiveData: true
      },
      () => {
        this.props.get_promotionList(
          this.state.versionPage,
          this.state.selectedYear,
          this.state.selectedWeekFrom,
          this.state.selectedWeekTo,
          this.state.selectedProductCategories,
          this.state.selectedProductBrands,
          this.state.selectedProductMasterSkus,
          this.state.selectedActivityStatus,
          this.state.selectedPromotionType,
          this.state.selectedActivityCode,
          this.state.selectedPushToDW,
          this.state.selectedIsextended,
          this.state.selectedInvoiceOption,
          this.state.selectedRPFailOption
        );
      }
    );
  };

  load_Versions() {
    if (
      this.props.isPromotionListLoading ||
      this.props.promotionListHasError ||
      this.state.data.results.length === this.state.totalData
    )
      return;
    this.setState(
      {
        versionPage: this.state.versionPage + 1,
        isLazyLoading: true,
        receiveData: true,
      },
      () => {
        this.props.get_promotionList(
          this.state.versionPage,
          this.state.selectedYear,
          this.state.selectedWeekFrom,
          this.state.selectedWeekTo,
          this.state.selectedProductCategories,
          this.state.selectedProductBrands,
          this.state.selectedProductMasterSkus,
          this.state.selectedActivityStatus,
          this.state.selectedPromotionType,
          this.state.selectedActivityCode,
          this.state.selectedPushToDW,
          this.state.selectedIsextended,
          this.state.selectedInvoiceOption,
          this.state.selectedRPFailOption

        );
      }
    );
  }

  load_more_versions = throttle(this.load_Versions, 800, {
    trailing: false,
  });
  componentWillUnmount() {
    this.setState({
      division: "",
      category: "",
      selectedPromotionType: "",
      selectedPromotionLevel: "",
      selectedProductDevisions: "",
      selectedProductCategories: [],
      selectedProductSkus: [],
      selectedProductMasterSkus: [],
      selectedProductBrands: [],
      promotionType: [],
      promotionLevelType: "",
      myBrands: [],
      mySkus: [],
      myMasterSkus: [],
      selectedProductVariants: [],
      selectedProductFormats: [],
      counter: this.props.counter,
      selected_row: false,
      versionPage: 1,
      //   versions:[],
      data: [],
      isDraftLoading: false,
      selectAll_row: false,
      isLazyLoading: false,
      firstTime: true,
      receiveData: true,
    });
  }

  handlePromotionChange = (e) => {
    if (e) {
      this.setState({ selectedPromotionType: e.value });
    }
  };

  handleCategory = (category) => {
    let arr = [];
    if (category === null || category.length === 0) {
      this.setState({
        selectedProductCategories: [],
        selectedProductBrands: [],
        selectedProductMasterSkus: [],
        selectedProductSkus: [],
        myBrands: [],
        myMasterSkus: [],
      });
    } else {
      category.forEach((element) => {
        arr.push(element.value);
      });

      this.setState({ selectedProductCategories: arr }, () => {
        this.handleFilteredBrands();
      });
    }
  };

  handleFilteredBrands = () => {
    const {
      selectedProductCategories,
      selectedProductBrands,
    } = this.state;
    const { product_brands } = this.props;
    let filteredbrands = [];
    if (selectedProductCategories.length) {
      for (let i = 0; i < selectedProductCategories.length; i++) {
        filteredbrands.push(
          ...product_brands.filter((item) => {
            return item.Category === selectedProductCategories[i];
          })
        );
      }
      let arr = [];
      if (selectedProductBrands.length) {
        filteredbrands.forEach(item => {
          if (selectedProductBrands.includes(item.guid)) {
            arr.push(item.guid)
          }
        })
        this.setState({ selectedProductBrands: arr });
      }
      this.setState({
        myBrands: filteredbrands,
      }, () => {
        this.handleFilteredMasterSku();
      });
    }
  };

  handleBrandChange = (selectedBrand) => {
    let arr = [];
    if (selectedBrand === null || selectedBrand.length === 0) {
      this.setState({
        selectedProductBrands: [],
        selectedProductMasterSkus: [],
        selectedProductSkus: [],
        myMasterSkus: [],
      });
    } else {
      selectedBrand.forEach((e) => {
        arr.push(e.value);
      });

      this.setState({ selectedProductBrands: arr }, () => {
        this.handleFilteredMasterSku();
      });
    }
  };

  handleFilteredMasterSku = () => {
    const {
      selectedProductBrands,
      selectedProductMasterSkus
    } = this.state;
    const { product_master_skus } = this.props;
    let filteredSkus = [];
    if (selectedProductBrands.length) {
      for (let i = 0; i < selectedProductBrands.length; i++) {
        filteredSkus.push(
          ...product_master_skus.filter((item) => {
            return item.Brand === selectedProductBrands[i];
          })
        );
      }

      let arr = [];
      if (selectedProductMasterSkus.length) {
        filteredSkus.forEach(item => {
          if (selectedProductMasterSkus.includes(item.guid)) {
            arr.push(item.guid)
          }
        })
        this.setState({ selectedProductMasterSkus: arr });
      }
      this.setState({
        myMasterSkus: filteredSkus,
      }, () => {
        this.handleFilteredSku();
      });
    }
  };

  handleMasterSkusChange = (selectedMasterSku) => {
    let arr = [];
    if (selectedMasterSku === null || selectedMasterSku.length === 0) {
      this.setState({ selectedProductMasterSkus: [], selectedProductSkus: [] });
    } else {
      selectedMasterSku.forEach((e) => {
        arr.push(e.value);
      });

      this.setState({ selectedProductMasterSkus: arr }, () => {
        this.handleFilteredSku();
      });
    }
  };

  handleFilteredSku() {
    const {
      selectedProductMasterSkus,
      selectedProductSkus
    } = this.state;
    const { product_skus } = this.props;
    let filteredSkus = [];
    if (selectedProductMasterSkus.length !== 0 && product_skus) {
      for (let i = 0; i < selectedProductMasterSkus.length; i++) {
        filteredSkus.push(
          ...product_skus.filter((item) => {
            return item.MasterSku === selectedProductMasterSkus[i];
          })
        );
      }

      let arr = [];
      if (selectedProductSkus.length) {
        filteredSkus.forEach(item => {
          if (selectedProductSkus.includes(item.guid)) {
            arr.push(item.guid)
          }
        })
        this.setState({ selectedProductSkus: arr });
      }

      this.setState({
        mySkus: filteredSkus,
      });
    }
  }

  handleSkusChange = (selectedSku) => {
    if (selectedSku) {
      let arr = [];
      selectedSku.forEach((element) => {
        arr.push(element.value);
      });

      this.setState({
        selectedProductSkus: arr,
      });
    } else if (selectedSku == null) {
      this.setState({ selectedProductSkus: [] });
    }
  };

  handleVariantsChange = (selectedVariants) => {
    if (selectedVariants) {
      let arr = [];
      selectedVariants.forEach((element) => {
        arr.push(element.value);
      });

      this.setState({
        selectedProductVariants: arr,
      });
    } else {
      this.setState({
        selectedProductVariants: [],
        selectedProductFormats: [],
      });
    }
  };

  handleFormatsChange = (selectedFormat) => {
    if (selectedFormat) {
      let arr = [];
      selectedFormat.forEach((element) => {
        arr.push(element.value);
      });

      this.setState({
        selectedProductFormats: arr,
      });
    } else {
      this.setState({ selectedProductFormats: [] });
    }
  };

  handleDevision = (selectedDevision) => {
    if (selectedDevision) {
      if (detailData) {
        this.setState({
          selectedProductDevisions: detailData.selectedProductDevisions,
        });
        detailData.selectedProductDevisions = "";
      }
      this.setState({ selectedProductDevisions: selectedDevision.value });
    }
  };

  handlePromotionLevel = (level) => {
    if (level) {
      if (detailData) {
        this.setState({
          selectedPromotionLevel: detailData.selectedPromotionLevel
            ? detailData.selectedPromotionLevel
            : void 0,
        });
        detailData.selectedPromotionLevel = "";
      }
      this.setState({
        selectedPromotionLevel: level.value,
        promotionLevelType: level.label,
      });
    }
  };

  handlePromotionType = (type) => {
    // console.log(type);
    // if (type) {
    //   if (detailData) {
    //     this.setState({
    //       selectedPromotionType: detailData.selectedPromotionType
    //         ? detailData.selectedPromotionType
    //         : void 0,
    //     });
    //     detailData.selectedPromotionType = "";
    //   }
    //   this.setState({ selectedPromotionType: type.value });
    // } else {
    //   this.setState({ selectedPromotionType: "" });
    // }
    let arr = [];
    if (type === null || type.length === 0) {
      this.setState({ selectedPromotionType: [] });
    } else {
      type.forEach((e) => {
        arr.push(e.value);
      });

      this.setState({ selectedPromotionType: arr }, () => {
        // this.handleFilteredSku();
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {


    if (prevProps.newDraft !== this.props.newDraft) {
      if (this.props.newDraft?.guid) {
        this.props.history.push(
          `/gtform/${this.props.newDraft.guid}?activity_status=draft/${this.state.formType}`
        );
      }
      this.forceUpdate();
    }
    if (prevProps.promotion_list !== this.props.promotion_list) {
      if (
        this.props.promotion_list &&
        this.props.promotion_list.results &&
        this.state.firstTime === true
      ) {
        this.setState({ data: this.props.promotion_list, firstTime: false });
      }
    }
  }

  creatNewDraft = (value) => {
    this.setState({ isDraftLoading: true, formType: value });
    let data;
    if (value === "mt") {
      data = {
        ActivityMetadata: {
          product_detail: {
            promotion_type: "88a78f88-99fd-4095-bddf-30aebe350dcd",
          },
        },
        PreOpso: {},
        guid: "",
      };
    }
    if (value === "gt") {
      data = { ActivityMetadata: {}, PreOpso: {}, guid: "" };
    }
    if (value === "ic") {
      data = { ActivityMetadata: {}, PreOpso: {}, guid: "" };
    }
    this.props.post_saveDraft(data, value);
  };

  selectRow = (index) => {
    const { data } = this.state;
    if (index === true) {
      data.results.forEach((e, i) => {
        const nextState = data;
        nextState.results.slice(0);
        if (
          nextState.results[i].selected === true &&
          this.state.selectAll_row === true
        ) {
          nextState.results[i].selected = false;
          this.setState({
            data: nextState,
            selectAll_row: !this.state.selectAll_row,
          });
        } else {
          nextState.results[i].selected = true;
          this.setState({ data: nextState, selectAll_row: true });
        }
      });
    } else {
      const nextState = data;
      nextState.results.slice(0);
      if (nextState.results[index].selected === true) {
        nextState.results[index].selected = false;
        this.setState({ data: nextState });
      } else {
        nextState.results[index].selected = true;
        this.setState({ data: nextState });
      }
    }
  };

  handleActivityOpen = (item) => {
    let currentFormType = item.promotion_type === "MTFTS" ? "mt" :
      ((item.promotion_type === "TPR" || item.promotion_type === "SBB") && item.categories[0] === "ICE CREAM") ? "ic" : "gt";
    this.setState({ formType: currentFormType });
    let user = JSON.parse(localStorage.getItem("myData"));
    let groupUser = user.user.groups[0];
    if (groupUser === "ACOM") {
      if (
        item.status === "Draft" ||
        item.status === "Sent Back By CDF" ||
        item.status === "Sent Back By CDFM" ||
        item.status === "Sent Back By CMD" ||
        (item.status === "Extended By ACOM" && item.IsExtended === true)
      ) {
        window.open(
          `/gtform/${item.guid}?activity_status=${item.status === "Draft" ? item.status.toLowerCase() : item.status
          }/${currentFormType}`,
          "_blank"
        );
        this.props.emptyNewdraft();
      } else {
        window.open(
          `/promotionapproval/${item.guid}?activity_status=${item.status}&${item.ActivityCode}`,
          "_blank"
        );
      }
    } else {
      window.open(
        `/promotionapproval/${item.guid}?activity_status=${item.status}&${item.ActivityCode}`,
        "_blank"
      );
    }
  };

  handleStatusType = (status) => {
    if (!status || status === undefined) {
      this.setState({ selectedActivityStatus: [] });
    } else {
      let arr = [];
      status.forEach((element) => {
        arr.push(element.value);
      });
      this.setState({ selectedActivityStatus: arr });
    }
  };

  handleYearChange = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        selectedYear: selectedValue.value,
      });
    } else {
      this.setState({
        selectedYear: "",
      });
    }
  };

  handleWeekFromChange = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        selectedWeekFrom: selectedValue.value,
        selectedWeekTo: "",
      });
    } else {
      this.setState({
        selectedWeekFrom: "",
        selectedWeekTo: "",
      });
    }
  };

  handleWeekToChange = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        selectedWeekTo: selectedValue.value,
      });
    } else {
      this.setState({
        selectedWeekTo: "",
      });
    }
  };

  hanldeActivityCodeInput = (e) => {
    let val = e.target.value;
    if (val) {
      var array = val.split(",");
      this.setState({
        activityCode: val,
        selectedActivityCode: array,
      });
    } else {
      this.setState({
        activityCode: val,
        selectedActivityCode: [],
      });
    }
  };

  submitFilter = () => {
    this.setState(
      {
        versionPage: 1,
        data: [],
        firstTime: true,
        receiveData: true,
      },
      () => {
        this.props.get_promotionList(
          this.state.versionPage,
          this.state.selectedYear,
          this.state.selectedWeekFrom,
          this.state.selectedWeekTo,
          this.state.selectedProductCategories,
          this.state.selectedProductBrands,
          this.state.selectedProductMasterSkus,
          this.state.selectedActivityStatus,
          this.state.selectedPromotionType,
          this.state.selectedActivityCode,
          this.state.selectedPushToDW,
          this.state.selectedIsextended,
          this.state.selectedInvoiceOption,
          this.state.selectedRPFailOption

        );
      }
    );
  };

  handleDeletePromotion = (item, index) => {
    let arr = [item.guid];
    this.setState({
      removePromo: true,
    });
    this.props.delete_promotion(arr);
  };

  handleBulkApprove = () => {
    let guidArray = [];
    this.state.data.results.forEach((item) => {
      if (item.selected) {
        guidArray.push(item.guid);
      }
    });
    if (guidArray.length) {
      this.props.bulk_approve_promotion(guidArray);
    } else {
      // ToastsStore.error("Promotion is not selected!");
      CustomToast("error", "Promotion is not selected!");
    }
  };

  handleBulkRPCall = () => {
    let guidArray = [];
    let count = 0;
    this.state.data.results.forEach((item) => {
      if (item.selected) {
        if (item.is_rp_failed) {
          guidArray.push(item.guid);
        } else {
          count = count + 1;
        }
      }
    });


    if (guidArray.length && count === 0) {
      this.setState({
        bulkRPCall: true,
      });
      this.props.bulk_rp_call(guidArray);
    } else {
      CustomToast('error', 'You are not allowed to perform this action for these activities')
    }
  }

  handleBulkSendBack = () => {
    const user = JSON.parse(localStorage.getItem("myData"));
    const groupUser = user.user.groups[0];
    let guidArray = [];
    let count = 0;
    if (groupUser === "CDF") {
      this.state.data.results.forEach((item) => {
        if (item.selected) {
          if (item.status === "Submitted By Acom") {
            guidArray.push(item.guid);
          } else {
            count = count + 1;
          }
        }
      });
    } else if (groupUser === "CDFM") {
      this.state.data.results.forEach((item) => {
        if (item.selected) {
          if (item.status === "Approved By CDF") {
            guidArray.push(item.guid);
          } else {
            count = count + 1;
          }
        }
      });
    } else if (groupUser === "CMD") {
      this.state.data.results.forEach((item) => {
        if (item.selected) {
          if (item.status === "Approved By CDFM") {
            guidArray.push(item.guid);
          } else {
            count = count + 1;
          }
        }
      });
    }
    if (guidArray.length && count === 0) {
      this.setState({
        bulkSendback: true,
      });
      this.props.bulk_send_back_promotion(guidArray);
    } else {
      CustomToast(
        "error",
        "You are not allowed to perform this action for these activities"
      );
    }
  };

  handleBulkDuplicate = (year, loading) => {
    let guidArray = [];
    let count = 0;
    this.state.data.results.forEach((item) => {
      if (item.selected) {
        if (item.status !== "Draft" && item.status !== "Extended By ACOM") {
          guidArray.push(item.guid);
        } else {
          count = count + 1;
        }
      }
    });
    if (loading) {
      this.setState({
        bulkDuplicate: true,
        duplicationLoading: true,
      });
    }
    if (guidArray.length && count === 0) {
      this.setState({
        bulkDuplicate: true,
      });
      this.props.bulk_duplicate_promotion(guidArray, year);
    } else {
      this.setState({ duplicationLoading: false });
      CustomToast("error", "Can not duplicate draft or extended promotions!");
    }
  };


  handleBulkDuplicateNextYear = (year, loading) => {
    let guidArray = [];
    let count = 0;
    let selectedActivityCount = 0;

    this.state.data.results.forEach((item) => {
      if (item.selected) {
        selectedActivityCount++;
        if (item.status !== "Draft" && item.status !== "Extended By ACOM") {
          guidArray.push(item.guid);
        } else {
          count = count + 1;
        }
      }
    });
    if (selectedActivityCount > 50) {
      CustomToast("warning", "You can not select more than 25 promotions!");
    } else {
      let confirmation = window.confirm("This operation will push the promotions in Data Warehouse as well. Are you sure you want to proceed?");
      if (confirmation) {
        if (loading) {
          this.setState({
            bulkDuplicate: true,
            duplicationLoading: true,
          });
        }
        if (guidArray.length && count === 0) {
          this.setState({
            bulkDuplicate: true,
          });
          this.props.bulk_duplicate_next_year_promotion(guidArray, year);
        } else {
          this.setState({ duplicationLoading: false });
          CustomToast("error", "Can not duplicate draft or extended promotions!");
        }
      }
    }
  };

  handleSingleDuplicate = (item, year) => {
    if (item) {
      let arr = [item.guid];
      this.props.bulk_duplicate_promotion(arr, year);
    }
  };

  handleExtend = (item) => {
    if (item && !item.IsExtended) {
      this.props.promotion_extension(item.guid);
    } else {
      CustomToast(
        "error",
        "This activity is already extended and cannot extend further. Please create a new activity."
      );
    }
  };

  handleSingleApprove = (item) => {
    if (item) {
      let arr = [item.guid];
      this.props.bulk_approve_promotion(arr);
    }
  };

  handleDownloadXlsx = () => {
    this.props.download_promotion_list_Xlx(
      this.state.versionPage,
      this.state.selectedYear,
      this.state.selectedWeekFrom,
      this.state.selectedWeekTo,
      this.state.selectedProductCategories,
      this.state.selectedProductBrands,
      this.state.selectedProductMasterSkus,
      this.state.selectedActivityStatus,
      this.state.selectedPromotionType,
      this.state.selectedActivityCode
    );
  };

  handleDateFormat = (value) => {
    var d = new Date(value);
    let date_ = d.toDateString().split(" ");
    return (
      date_[2] +
      `${date_[2] == 1       // eslint-disable-line
        ? "st"
        : date_[2] == 2       // eslint-disable-line
          ? "nd"
          : date_[2] == 3       // eslint-disable-line
            ? "rd"
            : "th"
      }` +
      ` ` +
      date_[1] +
      ` ` +
      date_[3]
    );
  };

  handleTimeFormat = (value) => {
    var d = new Date(value);
    var hours = d.getHours();
    var minutes = d.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  };
  //--------------
  handleClose = () => { };

  handleToggle = () => {
    this.setState({ open: !this.state.open });
  };

  handlePushToDW = (value) => {
    if (value === null) {
      this.setState({
        selectedPushToDW: "",
      });
    } else {
      this.setState({
        selectedPushToDW: value.value,
      });
    }
  }

  handleRPFailCall = (value) => {
    if (value === null) {
      this.setState({
        selectedRPFailOption: ''
      })
    } else {
      this.setState({
        selectedRPFailOption: value.value
      })
    }
  }

  handleInvoiceFilter = (value) => {
    if (value === null) {
      this.setState({
        selectedInvoiceOption: ''
      })
    } else {
      this.setState({
        selectedInvoiceOption: value.value
      })
    }
  }

  handleisExtended = (value) => {
    if (value === null) {
      this.setState({
        selectedIsextended: "",
      });
    } else {
      this.setState({
        selectedIsextended: value.value,
      });
    }
  };

  handleBulkCalculateCall = () => {
    this.props.promotion_bulk_caluclate(this.state.versionPage)
  }

  render(props) {
    const user = JSON.parse(localStorage.getItem("myData"));
    const groupUser = user.user.groups[0];
    const {
      selectedPromotionType,
      myBrands,
      myMasterSkus,
      selectedProductMasterSkus,
      selectedProductCategories,
      selectedProductDevisions,
      selectedProductBrands,
      selectedActivityStatus,
    } = this.state;
    const {
      promotion_types,
      product_devisions,
      product_categories,
    } = this.props;

    let selectedCodes = [];
    return (
      <>
        {this.state.data.length === 0 ? <Loader flag={true} /> : void 0}
        <div
          style={
            this.state.data.length !== 0
              ? { display: "block" }
              : { display: "none", opacity: 0 }
          }
          className="promotion_list_body"
        >
          <div className="heading-and-download-container">
            <div className='component-heading' style={{ padding: 0 }}>Promotion List</div>
            <div>
              <img
                style={{ marginLeft: "16px", cursor: "pointer" }}
                src={require("../assets/images/downloadIcon.svg")}
                onClick={() => this.handleDownloadXlsx()}
                alt=""
              />
            </div>
          </div>
          <div className="header">
            <div className="headers_controller">
              <div className="selectors ">
                <CustomSelect.MyCustomSelect
                  className="select-box"
                  placeholder="Divisions"
                  allowSelectAll={false}
                  options={
                    product_devisions
                      ? product_devisions.map((item) => ({
                        value: item.guid,
                        label: item.Name,
                      }))
                      : []
                  }
                  value={
                    product_devisions
                      ? product_devisions
                        .filter((item) => {
                          return !selectedProductDevisions
                            ? void 0
                            : item.guid === selectedProductDevisions;
                        })
                        .map((item) => {
                          return {
                            value: item.guid,
                            label: item.Name,
                          };
                        })
                      : null
                  }
                  onChange={this.handleDevision}
                />
                <CustomSelect.MyCustomSelect
                  placeholder={"Category"}
                  allowSelectAll={true}
                  isMulti
                  options={
                    product_categories
                      ? !product_categories
                        ? void 0
                        : product_categories.sort(compare).map((item) => ({
                          value: item.guid,
                          label: item.Name,
                        }))
                      : []
                  }
                  onChange={this.handleCategory}
                  value={
                    product_categories
                      ? product_categories
                        .filter((item) => {
                          return !selectedProductCategories
                            ? void 0
                            : selectedProductCategories.includes(item.guid);
                        })
                        .map((item) => {
                          return {
                            value: item.guid,
                            label: item.Name,
                          };
                        })
                      : void 0
                  }
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"Brand"}
                  allowSelectAll={true}
                  isMulti
                  options={
                    myBrands
                      ? myBrands.sort(compare).map((item) => ({
                        value: item.guid,
                        label: item.Name,
                      }))
                      : void 0
                  }
                  onChange={this.handleBrandChange}
                  value={
                    myBrands
                      ? myBrands
                        .filter((item) => {
                          return selectedProductBrands.includes(item.guid);
                        })
                        .map((item) => {
                          return {
                            value: item.guid,
                            label: item.Name,
                          };
                        })
                      : null
                  }
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"Master SKU"}
                  allowSelectAll={true}
                  isMulti
                  options={
                    myMasterSkus
                      ? myMasterSkus.sort(compare).map((item) => ({
                        value: item.guid,
                        label: item.Description,
                      }))
                      : void 0
                  }
                  onChange={this.handleMasterSkusChange}
                  value={
                    myMasterSkus
                      ? myMasterSkus
                        .filter((item) => {
                          return selectedProductMasterSkus.includes(
                            item.guid
                          );
                        })
                        .map((item) => {
                          return {
                            value: item.guid,
                            label: item.Description,
                          };
                        })
                      : null
                  }
                />

                <CustomSelect.MyCustomSelect
                  // className="select-box"
                  placeholder="Promotion Type"
                  allowSelectAll={true}
                  isMulti
                  options={
                    promotion_types
                      ? promotion_types.map((item) => ({
                        value: item.guid,
                        label: item.Label,
                      }))
                      : []
                  }
                  value={
                    promotion_types
                      ? promotion_types
                        .filter((item) => {
                          return selectedPromotionType.includes(item.guid);
                        })
                        .map((item) => {
                          return {
                            value: item.guid,
                            label: item.Label,
                          };
                        })
                      : null
                  }
                  onChange={this.handlePromotionType}
                // className="promotion_type"
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"Status"}
                  allowSelectAll={true}
                  isMulti
                  options={
                    DATA.ACTIVITY_STATUS
                      ? DATA.ACTIVITY_STATUS.map((item) => ({
                        value: item.value,
                        label: item.label.toUpperCase(),
                      }))
                      : []
                  }
                  onChange={this.handleStatusType}
                  value={
                    DATA.ACTIVITY_STATUS
                      ? DATA.ACTIVITY_STATUS.filter(item => {
                        return !selectedActivityStatus
                          ? []
                          : selectedActivityStatus.includes(item.value);
                      }).map((item) => {
                        return {
                          value: item.value,
                          label: item.label.toUpperCase(),
                        };
                      })
                      : void 0
                  }
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"Years"}
                  isClearable={false}
                  options={DATA.YEARS.map((item) => ({
                    value: item.value,
                    label: item.label,
                  }))}
                  value={DATA.YEARS.filter((item) => {
                    return !this.state.selectedYear
                      ? void 0
                      : item.value === this.state.selectedYear;
                  }).map((item) => {
                    return {
                      value: item.value,
                      label: item.label,
                    };
                  })}
                  onChange={this.handleYearChange}
                  className="select-box"
                />

                <CustomSelect.MyCustomSelect
                  placeholder="Week Start From"
                  isClearable={true}
                  className="select-box"
                  options={DATA.WEEK_NO.map((item) => ({
                    value: item.value,
                    label: item.label,
                  }))}
                  onChange={this.handleWeekFromChange}
                  value={
                    DATA.WEEK_NO
                      ? DATA.WEEK_NO.filter((item) => {
                        return !this.state.selectedWeekFrom
                          ? void 0
                          : item.value === this.state.selectedWeekFrom;
                      }).map((item) => {
                        return {
                          value: item.value,
                          label: item.label,
                        };
                      })
                      : void 0
                  }
                />

                <CustomSelect.MyCustomSelect
                  placeholder="Week Start To"
                  isClearable={true}
                  className="select-box"
                  options={
                    this.state.selectedWeekFrom
                      ? DATA.WEEK_NO.filter((item) => {
                        return item.value >= this.state.selectedWeekFrom;
                      }).map((item) => ({
                        value: item.value,
                        label: item.label,
                      }))
                      : []
                  }
                  onChange={this.handleWeekToChange}
                  value={
                    DATA.WEEK_NO
                      ? DATA.WEEK_NO.filter((item) => {
                        return !this.state.selectedWeekTo
                          ? void 0
                          : item.value === this.state.selectedWeekTo;
                      }).map((item) => {
                        return {
                          value: item.value,
                          label: item.label,
                        };
                      })
                      : void 0
                  }
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"Invoice"}
                  className='select-box'
                  isClearable={true}
                  options={
                    this.state.invoiceOptios.map((item) => ({
                      value: item.value,
                      label: item.name,
                    }))
                  }
                  onChange={this.handleInvoiceFilter}
                  value={this.state.invoiceOptios
                    .filter(item => {
                      return item.value === this.state.selectedInvoiceOption;
                    })
                    .map(item => {
                      return {
                        value: item.value,
                        label: item.name
                      };
                    })}
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"Push to DW"}
                  className="select-box"
                  isClearable={true}
                  options={this.state.pushToDWOptios.map((item) => ({
                    value: item.value,
                    label: item.name,
                  }))}
                  onChange={this.handlePushToDW}
                  value={this.state.pushToDWOptios
                    .filter((item) => {
                      return item.value === this.state.selectedPushToDW;
                    })
                    .map((item) => {
                      return {
                        value: item.value,
                        label: item.name,
                      };
                    })}
                />

                {
                  groupUser === 'System Admin' ?
                    <CustomSelect.MyCustomSelect
                      placeholder={"RP Fail"}
                      className='select-box'
                      isClearable={true}
                      options={
                        this.state.pushToDWOptios.map((item) => ({
                          value: item.value,
                          label: item.name,
                        }))
                      }
                      onChange={this.handleRPFailCall}
                      value={this.state.pushToDWOptios
                        .filter(item => {
                          return item.value === this.state.selectedRPFailOption;
                        })
                        .map(item => {
                          return {
                            value: item.value,
                            label: item.name
                          };
                        })}
                    />
                    :
                    null
                }

                <CustomSelect.MyCustomSelect
                  placeholder={"Is Extended"}
                  className="select-box"
                  isClearable={true}
                  options={this.state.is_extended.map((item) => ({
                    value: item.value,
                    label: item.name,
                  }))}
                  onChange={this.handleisExtended}
                  value={this.state.is_extended
                    .filter((item) => {
                      return item.value === this.state.selectedIsextended;
                    })
                    .map((item) => {
                      return {
                        value: item.value,
                        label: item.name,
                      };
                    })}
                />

                <div className="search_field">
                  <input
                    className="__input_text"
                    placeholder="Search by Activity Code or ProjectCode"
                    value={this.state.activityCode}
                    onChange={this.hanldeActivityCodeInput}
                  />
                  <img
                    src={require("./gt/images/search.svg")}
                    className="search_icon"
                    alt=""
                  />
                </div>

                {/* <div className="control_submit">
                  <button
                    className="__submit_button"
                    onClick={this.submitFilter}
                  >
                    Submit
                  </button>
                </div> */}
              </div>
            </div>

            <div className="headers_action" style={{ flexDirection: "column" }}>
              <div className="control_submit">
                <button className="__submit_button" onClick={this.submitFilter}>
                  SUBMIT
                </button>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {groupUser === "ACOM" ? (
                  <div
                    className="headers_action"
                    style={{ width: "fit-content" }}
                  >
                    <div style={{ display: "none" }}>
                      <label className="bulk_label">
                        {" "}
                        <u className="bulk_label">
                          {" "}
                          Bulk Duplicate For 2021{" "}
                        </u>{" "}
                      </label>
                    </div>

                    <div>
                      <Button
                        className="create_new"
                        aria-haspopup="true"
                        onClick={this.handleToggle}
                      >
                        + Create New
                        <Popper
                          open={this.state.open}
                          style={{
                            width: "146px",
                            position: "absolute",
                            top: "40px",
                            right: "0px",
                            zIndex: "1"
                          }}
                          transition
                          disablePortal
                        >
                          {({ TransitionProps, placement }) => (
                            <Grow
                              {...TransitionProps}
                              style={{
                                transformOrigin:
                                  placement === "bottom"
                                    ? "center top"
                                    : "center bottom",
                              }}
                            >
                              <Paper className="select-type">
                                <ClickAwayListener
                                  onClickAway={this.handleClose}
                                >
                                  {/* <MenuList
                                    autoFocusItem={this.state.open}
                                    id="menu-list-grow"
                                    className="promo-menu"
                                  > */}
                                    {
                                      this.state.onlyIceCream ?
                                        <MenuList
                                          autoFocusItem={this.state.open}
                                          id="menu-list-grow"
                                          className="promo-menu"
                                        >
                                          <MenuItem
                                            className="promo-menu-item"
                                            onClick={() => this.creatNewDraft("ic")}
                                          >
                                            IC Promotion
                                          </MenuItem>
                                        </MenuList>
                                        :
                                        <MenuList
                                          autoFocusItem={this.state.open}
                                          id="menu-list-grow"
                                          className="promo-menu"
                                        >
                                          {
                                            this.state.isIceCream &&
                                            <MenuItem
                                              className="promo-menu-item"
                                              onClick={() => this.creatNewDraft("ic")}
                                            >
                                              IC Promotion
                                            </MenuItem>
                                          }
                                          <MenuItem
                                            className="promo-menu-item"
                                            onClick={() => this.creatNewDraft("gt")}
                                          >
                                            GT Promotion
                                          </MenuItem>
                                          <MenuItem
                                            className="promo-menu-item"
                                            onClick={() => this.creatNewDraft("mt")}
                                          >
                                            MT Promotion
                                          </MenuItem>
                                        </MenuList>
                                    }
                                    {/* <MenuItem
                                      className="promo-menu-item"
                                      onClick={() => this.creatNewDraft("gt")}
                                    >
                                      GT Promotion
                                    </MenuItem>
                                    <MenuItem
                                      className="promo-menu-item"
                                      onClick={() => this.creatNewDraft("mt")}
                                    >
                                      MT Promotion
                                    </MenuItem> */}
                                  {/* </MenuList> */}
                                </ClickAwayListener>
                              </Paper>
                            </Grow>
                          )}
                        </Popper>
                      </Button>
                    </div>
                  </div>
                ) : null}
                <div>
                  {
                    // <img
                    //   style={{ marginLeft: "16px", cursor: "pointer" }}
                    //   src={require("../assets/images/downloadIcon.svg")}
                    //   onClick={() => this.handleDownloadXlsx()}
                    //   alt=""
                    // />
                  }
                </div>
              </div>

            </div>
          </div>

          <div
            className="promotion-list-table-container"
            ref={(c) => (this.page_wrapper_promotion = c)}
          >

            <table className='promotion-list-table'>

              <thead>

                <tr>

                  <th className='promolist-table-cell-padding header-cell-bg'>
                    <span
                      className="select_box"
                      onClick={this.selectRow.bind(this, true)}
                    >
                      {this.state.selectAll_row === true ? (
                        <img
                          src={require("./gt/images/tick.svg")}
                          className="__tick"
                          alt=""
                        />
                      ) : (
                        void 0
                      )}
                    </span>
                  </th>
                  <th
                    className='cell-without-white-warp header-cell-bg'
                    style={{ textAlign: 'left' }}
                  >
                    Activity Code
                  </th>
                  <th
                    className='cell-without-white-warp header-cell-bg'
                    style={{ textAlign: 'left' }}
                  >
                    Project Code
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Status
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Type
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Invoice
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Level
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Originator
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Year
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center', width: '48px' }}
                  >
                    Week ST & ED
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Date Created
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Time of Creation
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'left' }}
                  >
                    Category
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'left' }}
                  >
                    Brand
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'left' }}
                  >
                    MSKU
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Push To DW
                  </th>
                  {
                    groupUser === 'System Admin' ?
                      <th
                        className='promolist-table-cell-padding header-cell-bg'
                        style={{ textAlign: 'center' }}
                      >
                        RP Fail
                      </th>
                      :
                      null
                  }
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Extended
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'left' }}
                  >
                    Customer
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Tot Vol
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Total Cost
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    Inc Vol
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    ROI(%)
                  </th>
                  <th
                    className='promolist-table-cell-padding header-cell-bg'
                    style={{ textAlign: 'center' }}
                  >
                    View
                  </th>

                </tr>

              </thead>

              <tbody>

                {this.state.data.length === 0 ? (
                  <tr>
                    <td>No Data!</td>
                  </tr>
                ) : (
                  this.state.data.results.map((item, index) => {
                    item.selected === true &&
                      selectedCodes.push(item.selected);
                    return (
                      <tr
                        className='row-border'
                        style={
                          item.selected === true
                            ? { backgroundColor: "#e7f4fa" }
                            : void 0
                        }
                        key={index}
                      >
                        <td
                          className='promolist-table-cell-padding'>
                          <span
                            className="select_box"
                            onClick={this.selectRow.bind(this, index)}
                          >
                            {item.selected === true ? (
                              <img
                                src={require("./gt/images/tick.svg")}
                                className="__tick"
                                alt=""
                              />
                            ) : (
                              void 0
                            )}
                          </span>
                        </td>

                        <td
                          className='cell-without-white-warp'
                          style={{ cursor: "pointer" }}
                          onClick={() => this.handleActivityOpen(item)}
                        >
                          {item.ActivityCode ? item.ActivityCode : "--"}
                        </td>

                        <td
                          className='cell-without-white-warp'>
                          {item.ProjectCodes.map((elm, ind) =>
                            item.ProjectCodes.length - 1 === ind ? (
                              <div key={ind}>
                                {elm}
                                <br />
                              </div>
                            ) : (
                              <div key={ind}>
                                {elm + ", "}
                                <br />
                              </div>
                            )
                          )}
                          {item.ProjectCodes.length === 0 ? "--" : null}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          <span
                            className={
                              item.status === "Draft"
                                ? "status_draft"
                                : item.status === "Approved By CDF" ||
                                  item.status === "Approved By CDFM" ||
                                  item.status === "Approved By CMD"
                                  ? "status_approved"
                                  : item.status === "Rejected By CDF" ||
                                    item.status === "Rejected By CDFM" ||
                                    item.status === "Rejected By CMD"
                                    ? "status_reject"
                                    : item.status === "Submitted By Acom"
                                      ? "status_submit"
                                      : item.status === "Sent Back By CDF" ||
                                        item.status === "Sent Back By CDFM" ||
                                        item.status === "Sent Back By CMD"
                                        ? "status-send-back"
                                        : item.status === "Extended By ACOM"
                                          ? "status_extended"
                                          : void 0
                            }
                          >
                            {item.status}
                          </span>
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {item.promotion_type ? (
                            <span className="body_pro_type">
                              {item.promotion_type}
                            </span>
                          ) : (
                            "--"
                          )}
                        </td>
                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}>
                          {item.is_invoice_on || !item.is_invoice_on ? (
                            <span className="body_pro_type">
                              {item.is_invoice_on ? 'ON' : 'OFF'}
                            </span>
                          ) : (
                            "--"
                          )}
                        </td>
                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {item.promotion_level ? (
                            <span className="body_pro_type">
                              {item.promotion_level}
                            </span>
                          ) : (
                            "--"
                          )}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {item.first_name} {item.last_name}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {item.year ? item.year : "--"}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {item.WeekStart}-{item.WeekEnd}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {this.handleDateFormat(item.DateCreated)}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {this.handleTimeFormat(item.DateCreated)}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'left' }}>
                          {item.categories.length === 0 ? (
                            <span>--</span>
                          ) : (
                            item.categories
                              .filter((elm, indx) => {       // eslint-disable-line
                                if (indx < 1) {
                                  return elm;
                                }
                              })
                              .map((elm, ind) => (
                                <span className="prod_detail" key={ind}>
                                  {elm}
                                </span>
                              ))
                          )}
                          {item.categories.length > 1 ? (
                            <span className="prod_detail">
                              {/* <img
                                  src={require("./gt/images/dots.png")}
                                  alt=""
                                /> */}
                              <span style={{ color: '#3f7fc9' }}>
                                +{item.categories.length - 1} more
                              </span>
                              <div className="hidden_prod">
                                <ul className="hidden_list">
                                  {item.categories.map((elm, ind) => (
                                    <li key={ind}>{elm}</li>
                                  ))}
                                </ul>
                              </div>
                            </span>
                          ) : null}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'left' }}
                        >
                          {item.brands.length === 0 ? (
                            <span>--</span>
                          ) : (
                            item.brands
                              .filter((elm, indx) => {       // eslint-disable-line
                                if (indx < 1) {
                                  return elm;
                                }
                              })
                              .map((elm, ind) => (
                                <span key={ind} className="prod_detail">
                                  {elm}
                                </span>
                              ))
                          )}
                          {item.brands.length > 1 ? (
                            <span className="prod_detail">
                              {/* <img
                                  src={require("./gt/images/dots.png")}
                                  alt=""
                                /> */}
                              <span style={{ color: '#3f7fc9' }}>
                                +{item.brands.length - 1} more
                              </span>
                              <div className="hidden_prod">
                                <ul className="hidden_list">
                                  {item.brands.map((elm, ind) => (
                                    <li key={ind}>{elm}</li>
                                  ))}
                                </ul>
                              </div>
                            </span>
                          ) : null}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'left' }}>
                          {item.master_skus.length === 0 ? (
                            <span>--</span>
                          ) : (
                            item.master_skus
                              .filter((elm, indx) => {       // eslint-disable-line
                                if (indx < 1) {
                                  return elm;
                                }
                              })
                              .map((elm, ind) => (
                                <span key={ind} className="prod_detail">{elm}</span>
                              ))
                          )}
                          {item.master_skus.length > 1 ? (
                            <span className="prod_detail">
                              {/* <img src={require("./gt/images/dots.png")} alt='' /> */}
                              <span style={{ color: '#3f7fc9' }}>
                                +{item.master_skus.length - 1} more
                              </span>
                              <div className="hidden_prod">
                                <ul className="hidden_list">
                                  {item.master_skus.map((elm, ind) => (
                                    <li key={ind}>{elm}</li>
                                  ))}
                                </ul>
                              </div>
                            </span>
                          ) : null}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {item.PushToDwh || item.PushToDwh === false ? (
                            <span className="body_pro_type">
                              {item.PushToDwh.toString().toUpperCase()}
                            </span>
                          ) : (
                            "--"
                          )}
                        </td>

                        {
                          groupUser === 'System Admin' ?
                            <td
                              className='promolist-table-cell-padding'
                              style={{ textAlign: 'center' }}
                            >
                              {item.is_rp_failed || item.is_rp_failed === false ? (
                                <span className="body_pro_type">
                                  {item.is_rp_failed.toString().toUpperCase()}
                                </span>
                              ) : (
                                "--"
                              )}
                            </td>
                            :
                            null
                        }

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {item.IsExtended || item.IsExtended === false ? (
                            <span className="body_pro_type">
                              {item.IsExtended.toString().toUpperCase()}
                            </span>
                          ) : (
                            "--"
                          )}
                        </td>


                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'left' }}>
                          {item.direct_customers.length === 0 ? (
                            <span>--</span>
                          ) : (
                            item.direct_customers
                              .filter((elm, indx) => {       // eslint-disable-line
                                if (indx < 1) {
                                  return elm;
                                }
                              })
                              .map((elm, ind) => (
                                <span key={ind} className="prod_detail">
                                  {elm}
                                </span>
                              ))
                          )}
                          {item.direct_customers.length > 1 ? (
                            <span className="prod_detail">
                              {/* <img
                                  src={require("./gt/images/dots.png")}
                                  alt=""
                                /> */}<span style={{ backgroundColor: '#f4f5f9', color: '#3f7fc9' }}>
                                +{item.direct_customers.length - 1} more
                              </span>
                              <div className="hidden_prod">
                                <ul className="hidden_list">
                                  {item.direct_customers.map((elm, ind) => (
                                    <li key={ind}>{elm}</li>
                                  ))}
                                </ul>
                              </div>
                            </span>
                          ) : null}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {item.TotalVolume
                            ? valueConverter_2(item.TotalVolume)
                            : "--"}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {item.TotalCost
                            ? valueConverter_2(item.TotalCost)
                            : "--"}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {item.IncVolume
                            ? valueConverter_2(item.IncVolume)
                            : "--"}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          {item.Roi ? valueConverter_2(item.Roi) : "--"}
                        </td>

                        <td
                          className='promolist-table-cell-padding'
                          style={{ textAlign: 'center' }}
                        >
                          <div className="__view">
                            <label style={{ display: 'flex' }}>
                              {" "}
                              <img
                                src={require("./gt/images/dots.png")}
                                alt=""
                              />
                              <div
                                className={
                                  this.state.data.results.length - 1 ===
                                    index ||
                                    this.state.data.results.length - 2 === index
                                    ? "view_hiddenUP"
                                    : "view_hidden"
                                }
                                style={
                                  groupUser === "ACOM"
                                    ? null
                                    : { height: "4vw" }
                                }
                              >
                                {item.status === "Draft" ||
                                  item.status === "Extended By ACOM" ? (
                                  <ul className="hidden_list2">
                                    <li
                                      onClick={() =>
                                        this.handleActivityOpen(item)
                                      }
                                    >
                                      View
                                    </li>
                                    {!item.IsExtended &&
                                      item.status !== "Extended By ACOM" ? (
                                      <>
                                        {this.props.deletingPromotion ? (
                                          <li>Deleting..</li>
                                        ) : (
                                          <li
                                            onClick={() =>
                                              this.handleDeletePromotion(
                                                item,
                                                index
                                              )
                                            }
                                          >
                                            Delete{" "}
                                          </li>
                                        )}
                                      </>
                                    ) : null}
                                  </ul>
                                ) : (
                                  <ul className="hidden_list2">
                                    <li
                                      onClick={() =>
                                        this.handleActivityOpen(item)
                                      }
                                    >
                                      View
                                    </li>
                                    {groupUser === "ACOM" ? (
                                      <li
                                        onClick={() =>
                                          this.handleSingleDuplicate(
                                            item,
                                            this.state.currentYear
                                          )
                                        }
                                      >
                                        Duplicate
                                      </li>
                                    ) : null}

                                    {groupUser === "ACOM" &&
                                      item.status === "Approved By CMD" ? (
                                      <li
                                        onClick={() =>
                                          this.handleExtend(item)
                                        }
                                      >
                                        Extend
                                      </li>
                                    ) : null}
                                  </ul>
                                )}
                              </div>
                            </label>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}

              </tbody>

            </table>

          </div>

          {this.props.isPromotionListLoading ? <Loader flag={true} /> : void 0}
          {/* {console.log("groupUser", groupUser)}
          {console.log("selectedCodes", selectedCodes)}
          {console.log("this.state.currentMonth", this.state.currentMonth)}
          {console.log("this.state.selectedYear", this.state.selectedYear)} */}
          {/*zain ahmed: i have change condition in this part of code  */}
          <div className="__footerCt">
            {selectedCodes.length !== 0 && (
              <>
                <p className="__selectedCountr">
                  You have selected {selectedCodes.length} Activity Code
                </p>
                {groupUser === "ACOM" ? (
                  <>
                    {/* {this.state.currentMonth == '9' ||
                this.state.currentMonth == '10' ||
                this.state.currentMonth == '11' ? */}
                  {/* {this.state.currentMonth == "0" || */}
                  {this.state.selectedYear == this.state.currentYear ? (       // eslint-disable-line
                    <>
                      {this.state.duplicationLoading ? (
                        <button
                          className="__approveCt"
                          style={{ width: "13.5vw" }}
                        >
                          Duplicating...
                        </button>
                      ) : (
                          <button
                            className="__approveCt"
                            style={{ width: "13.5vw" }}
                            onClick={() => this.handleBulkDuplicate(this.state.currentYear+1,true)}
                            // onClick={() =>
                            //   this.handleBulkDuplicateNextYear(
                            //     this.state.currentYear,
                            //     true
                            //   )
                            // }
                          >
                            Bulk Duplicate for {this.state.currentYear+1}
                          {/* Bulk Duplicate for {this.state.currentYear} */}
                          </button>
                        )}
                      </>
                    ) : null}
                    {
                      parseInt(this.state.selectedYear) < parseInt(this.state.currentYear) ?
                        null
                        :
                        <button
                          className="__duplicateCt"
                          onClick={() =>
                            this.handleBulkDuplicate(this.state.currentYear, false)
                          }
                        >
                          Bulk Duplicate{" "}
                        </button>
                    }
                  </>
                ) : null}
                {
                  groupUser === "System Admin" ?
                    <button
                      className="__duplicateCt"
                      onClick={() => this.handleBulkRPCall()}
                    >
                      Bluk RP Call
                    </button>
                    :
                    null
                }
                {groupUser === "ACOM" || groupUser === "System Admin" ? null : (
                  <>
                    <button
                      className="__duplicateCt"
                      onClick={() => this.handleBulkSendBack()}
                    >
                      Bulk SendBack
                    </button>
                    <button
                      className="__approveCt"
                      onClick={() => this.handleBulkApprove()}
                    >
                      Bulk Approve
                    </button>
                  </>
                )}
              </>
            )}
            {
              groupUser === "ACOM" && parseInt(this.state.selectedYear) === this.state.currentYear ?
                <button
                  className="bulk-calculate-cta"
                  onClick={() => this.handleBulkCalculateCall()}
                >
                  Bulk AN Refresh
                </button>// Bulk Calculate text changed to Bulk AN Refresh
                :
                null
            }
          </div>
          {/* </>
        } */}
        </div>
      </>
    );
  }
}

// redux

const mapStateToProps = (state) => {
  return {
    promotion_types: state.PromotionReducer.promotionType,
    promotion_level: state.PromotionReducer.promotionLevel,
    // product reducer
    product_devisions: state.ProductReducer.productDevisions,
    product_categories: state.ProductReducer.productCategories,
    product_brands: state.ProductReducer.productBrands,
    product_skus: state.ProductReducer.productSkus,
    product_master_skus: state.ProductReducer.productMasterSkus,
    // product_variants: state.ProductReducer.productVariants,
    // product_formats: state.ProductReducer.producFormats,
    promotion_list: state.PromotionListReducer.promotionList,
    draftData: state.CreatePromotionReducer.draftData,
    newDraft: state.CreatePromotionReducer.newDraft,
    isPromotionListLoading: state.PromotionListReducer.isPromotionListLoading,
    promotionListHasError: state.PromotionListReducer.promotionListHasError,
    deletingPromotion: state.PromotionListReducer.deletingPromotion,
    promotionDeletedSuccessfully:
      state.PromotionListReducer.promotionDeletedSuccessfully,
    errorDeletingPromotion: state.PromotionListReducer.errorDeletingPromotion,
    bulkDuplicatedSuccessfully:
      state.PromotionListReducer.bulkDuplicatedSuccessfully,
    bulkSendBackSuccessfully: state.PromotionListReducer.bulkSendBackSuccessfully,
    promotion_extension_list: state.PromotionListReducer.promotion_extension,
    bulkRpCallSuccessfully: state.PromotionListReducer.bulkRpCallSuccessfully,
    bulkDuplicatedNextYearSuccessfully: state.PromotionListReducer.bulkDuplicatedNextYearSuccessfully

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    get_AllPromotionType: () => {
      return dispatch(PromotionMiddleware.get_AllPromotionType());
    },
    get_promotionLevel: () => {
      return dispatch(PromotionMiddleware.get_promotionLevel());
    },
    // product details
    get_productDevisions: () => {
      return dispatch(ProductMiddleware.get_devisions());
    },
    get_productCategories: () => {
      return dispatch(ProductMiddleware.get_categories());
    },
    get_productBrands: () => {
      return dispatch(ProductMiddleware.get_brands());
    },
    get_productSkus: () => {
      return dispatch(ProductMiddleware.get_skus());
    },
    get_productMasterSkus: () => {
      return dispatch(ProductMiddleware.get_master_skus());
    },
    // get_productVariants: () => {
    //   return dispatch(ProductMiddleware.get_variants());
    // },
    // get_productFormats: () => {
    //   return dispatch(ProductMiddleware.get_formats());
    // },
    get_promotionList: (
      versionPage,
      selectedYear,
      selectedWeekFrom,
      selectedWeekTo,
      selectedProductCategories,
      selectedProductBrands,
      selectedProductMasterSkus,
      selectedActivityStatus,
      selectedPromotionType,
      selectedActivityCode,
      selectedPushToDW,
      selectedIsextended,
      selectedInvoiceOption,
      selectedRPFailOption
    ) => {
      return dispatch(
        PromotionListMiddleware.get_promotionList(
          versionPage,
          selectedYear,
          selectedWeekFrom,
          selectedWeekTo,
          selectedProductCategories,
          selectedProductBrands,
          selectedProductMasterSkus,
          selectedActivityStatus,
          selectedPromotionType,
          selectedActivityCode,
          selectedPushToDW,
          selectedIsextended,
          selectedInvoiceOption,
          selectedRPFailOption
        )
      );
    },
    post_saveDraft: (data, type) => {
      return dispatch(CreatePromotion.post_saveDraft(data, type));
    },
    emptyNewdraft: () => {
      return dispatch(CreatePromotion.emptyNewdraft());
    },
    delete_promotion: (data) => {
      return dispatch(PromotionListMiddleware.delete_promotion(data));
    },
    bulk_approve_promotion: (data) => {
      return dispatch(PromotionListMiddleware.bulk_approve_promotion(data));
    },
    bulk_duplicate_promotion: (data, year) => {
      return dispatch(
        PromotionListMiddleware.bulk_duplicate_promotion(data, year)
      );
    },
    download_promotion_list_Xlx: (
      versionPage,
      selectedYear,
      selectedWeekFrom,
      selectedWeekTo,
      selectedProductCategories,
      selectedProductBrands,
      selectedProductMasterSkus,
      selectedActivityStatus,
      selectedPromotionType,
      selectedActivityCode
    ) => {
      return dispatch(
        PromotionListMiddleware.download_promotion_list_Xlx(
          versionPage,
          selectedYear,
          selectedWeekFrom,
          selectedWeekTo,
          selectedProductCategories,
          selectedProductBrands,
          selectedProductMasterSkus,
          selectedActivityStatus,
          selectedPromotionType,
          selectedActivityCode
        )
      );
    },

    bulk_send_back_promotion: (data) => {
      return dispatch(PromotionListMiddleware.bulk_send_back_promotion(data));
    },
    promotion_extension: (data) => {
      return dispatch(PromotionListMiddleware.promotion_extension(data));
    },
    bulk_rp_call: (data) => {
      return dispatch(PromotionListMiddleware.bulk_rp_call(data));
    },
    bulk_duplicate_next_year_promotion: (data, year) => {
      return dispatch(
        PromotionListMiddleware.bulk_duplicate_next_year_promotion(data, year)
      );
    },
    promotion_bulk_caluclate: (page) => {
      return dispatch(
        PromotionListMiddleware.promotion_bulk_caluclate(page)
      );
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PromotionList);
